import { CartProductSchema } from '../../types';
import { State } from '../types';
import { getAppIdentifier } from './utils';

export const getIdsOfLinkedProductsAndApps = ({
  productId,
  productsObj,
  appsObj,
}: {
  productId: CartProductSchema['id'];
  productsObj: State['products'];
  appsObj: State['linkedEntitlements'];
}): {
  productIds: string[];
  appIds: string[];
} => {
  const productArr: CartProductSchema[] = Object.values(productsObj);
  const product = productArr.find((product) => product.id === productId);
  if (!product) {
    return {
      appIds: [],
      productIds: [],
    };
  }

  const productContainerId = product.containerId;
  const productIds = productContainerId
    ? productArr
        .filter((product) => {
          return product.containerId === productContainerId && product.id !== productId;
        })
        .map((product) => product.id) ?? []
    : [];

  const appIdentifier = getAppIdentifier(product);
  const appIds = appsObj[appIdentifier]?.map((app) => app.id) ?? [];

  return {
    appIds,
    productIds,
  };
};
